<template>
  <v-container v-if="$auth.check()">
    <v-row>
      <v-col>
        <h1>{{ $t('texts.profile') }}</h1>
      </v-col>
    </v-row>
    <missing-information/>
    <v-row>
      <v-col>
        <v-card>
          <v-tabs
            v-model="active"
            slider-color="primary"
            color="transparent"
            active-class="text--primary"
            :show-arrows="$vuetify.breakpoint.smAndDown"
          >
            <v-tab
              ripple
              :to="{ path: `/company/${company.id}/profile/general` }"
            >
              {{ $t('texts.company.profile.general') }}
            </v-tab>
            <v-tab
              ripple
              :to="{ path: `/company/${company.id}/profile/images` }"
            >
              {{ $t('texts.company.profile.images') }}
            </v-tab>
            <v-tab
              ripple
              :to="{ path: `/company/${company.id}/profile/contact-person` }"
            >
              {{ $t('texts.contactPerson') }}
            </v-tab>
            <v-tabs-items v-model="active">
              <router-view/>
            </v-tabs-items>
          </v-tabs>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import MissingInformation from './MissingInformation.vue';

const { mapState: mapCompanyProfileState } = createNamespacedHelpers('company/profile');

export default {
  name: 'CompanyProfile',
  components: {
    MissingInformation,
  },
  data() {
    return {
      active: null,
    };
  },
  computed: {
    ...mapCompanyProfileState([
      'company',
    ]),
  },
};
</script>

<style lang="scss" scoped>
  ::v-deep {
    .v-tabs__item--active {
      color: #0d5890;
    }
  }
</style>
